// Recovered compiled webpack factory 51486. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "useUntrackedPathname", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(12115),
    a = r(3865);
  function o() {
    return (0, n.useContext)(a.PathnameContext);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
